/* eslint-disable simple-import-sort/imports */
import '@/config/sentry'

import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'jotai'

import { store } from './store/store'
import App from './App'
import Modals from './components/Modals'
import { AuthProvider } from './features/Auth/components/AuthProvider'
import { Version } from './components/Version'

import 'react-datepicker/dist/react-datepicker.css'
import 'modern-normalize/modern-normalize.css'
import './App.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
          <Toaster />
          <Version />
          <Modals />
        </AuthProvider>
      </QueryClientProvider>
    </Provider>
  </StrictMode>,
)
